<div class="row">
  <div class="col">
    <div class="noselect" style="position: relative;">
      <img draggable="false" (load)="initializeDimensions()" (error)="error()" #myimg style="width: 100%;"
           [src]="image?.original"/>

      <ng-container></ng-container>

      <div #overlay (resized)="onResized($event)" class="dragOverlay" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0;">
        <ng-container *ngIf="cropArea">
          <div class="cutoutOverlay"
               [style.left.px]="leftOverlay.left"
               [style.top.px]="leftOverlay.top"
               [style.right.px]="leftOverlay.right"
               [style.bottom.px]="leftOverlay.bottom"></div>
          <div class="cutoutOverlay"
               [style.left.px]="topOverlay.left"
               [style.top.px]="topOverlay.top"
               [style.right.px]="topOverlay.right"
               [style.bottom.px]="topOverlay.bottom"></div>
          <div class="cutoutOverlay"
               [style.left.px]="rightOverlay.left"
               [style.top.px]="rightOverlay.top"
               [style.right.px]="rightOverlay.right"
               [style.bottom.px]="rightOverlay.bottom"></div>
          <div class="cutoutOverlay"
               [style.left.px]="bottomOverlay.left"
               [style.top.px]="bottomOverlay.top"
               [style.right.px]="bottomOverlay.right"
               [style.bottom.px]="bottomOverlay.bottom"></div>
          <div *ngIf="!dragging" #rectangle
               [style.width.px]="cropArea.width"
               [style.height.px]="cropArea.height"
               cdkDrag
               [cdkDragFreeDragPosition]="position"
               cdkDragBoundary=".dragOverlay"
               (cdkDragStarted)="moveDragStarted($event)"
               (cdkDragMoved)="moveDragMoved($event)"
               (cdkDragEnded)="moveDragEnded($event)"
               class="selectionRectangle"></div>
          <div *ngIf="dragging"
               [style.left.px]="cropArea.topLeft.x"
               [style.top.px]="cropArea.topLeft.y"
               [style.right.px]="containerWidth - cropArea.bottomRight.x"
               [style.bottom.px]="containerHeight - cropArea.bottomRight.y"
               class="selectionRectangle"></div>
          <div #left class="handle ew-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="leftPos"
               cdkDragBoundary=".dragOverlay"
               cdkDragLockAxis="x"
               (cdkDragStarted)="resizeDragStarted($event, 'left')"
               (cdkDragMoved)="resizeDragMoved($event, 'left')"
               (cdkDragEnded)="resizeDragEnded($event, 'left')"
          ></div>
          <div #topleft class="handle nw-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="topLeftPos"
               cdkDragBoundary=".dragOverlay"
               (cdkDragStarted)="resizeDragStarted($event, 'topLeft')"
               (cdkDragMoved)="resizeDragMoved($event, 'topLeft')"
               (cdkDragEnded)="resizeDragEnded($event, 'topLeft')"
          ></div>
          <div #top class="handle ns-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="topPos"
               cdkDragBoundary=".dragOverlay"
               cdkDragLockAxis="y"
               (cdkDragStarted)="resizeDragStarted($event, 'top')"
               (cdkDragMoved)="resizeDragMoved($event, 'top')"
               (cdkDragEnded)="resizeDragEnded($event, 'top')"
          ></div>
          <div #topright class="handle ne-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="topRightPos"
               cdkDragBoundary=".dragOverlay"
               (cdkDragStarted)="resizeDragStarted($event, 'topRight')"
               (cdkDragMoved)="resizeDragMoved($event, 'topRight')"
               (cdkDragEnded)="resizeDragEnded($event, 'topRight')"
          ></div>
          <div #right class="handle ew-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="rightPos"
               cdkDragBoundary=".dragOverlay"
               cdkDragLockAxis="x"
               (cdkDragStarted)="resizeDragStarted($event, 'right')"
               (cdkDragMoved)="resizeDragMoved($event, 'right')"
               (cdkDragEnded)="resizeDragEnded($event, 'right')"
          ></div>
          <div #bottomright class="handle se-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="bottomRightPos"
               cdkDragBoundary=".dragOverlay"
               (cdkDragStarted)="resizeDragStarted($event, 'bottomRight')"
               (cdkDragMoved)="resizeDragMoved($event, 'bottomRight')"
               (cdkDragEnded)="resizeDragEnded($event, 'bottomRight')"
          ></div>
          <div #bottom class="handle ns-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="bottomPos"
               cdkDragBoundary=".dragOverlay"
               cdkDragLockAxis="y"
               (cdkDragStarted)="resizeDragStarted($event, 'bottom')"
               (cdkDragMoved)="resizeDragMoved($event, 'bottom')"
               (cdkDragEnded)="resizeDragEnded($event, 'bottom')"
          ></div>
          <div #bottomleft class="handle sw-resize"
               [style.width.px]="handleSize"
               [style.height.px]="handleSize"
               cdkDrag
               [cdkDragFreeDragPosition]="bottomLeftPos"
               cdkDragBoundary=".dragOverlay"
               (cdkDragStarted)="resizeDragStarted($event, 'bottomLeft')"
               (cdkDragMoved)="resizeDragMoved($event, 'bottomLeft')"
               (cdkDragEnded)="resizeDragEnded($event, 'bottomLeft')"
          ></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
